import React, { useCallback, memo } from 'react';
import DateRange, { DateRangeLabel } from '../date-range/DateRange';

interface ReportSettingFromToProps {
  onChange: (updatedValue: ReportSettingFromToState) => void;
  reportSettingState: ReportSettingFromToState;
}

export interface ReportSettingFromToState {
  from: string;
  to: string;
  isValid: boolean;
}

function ReportDateSettingFromTo({
  onChange,
  reportSettingState,
}: ReportSettingFromToProps): JSX.Element {
  const dateRangeLabel: DateRangeLabel = { Start: 'From', End: 'To' };

  return (
    <>
      <DateRange
        onChange={useCallback(
          (from: string, to: string, isValid: boolean): void => {
            onChange({
              ...reportSettingState,
              from: from,
              to: to,
              isValid: isValid,
            });
          },
          [onChange, reportSettingState],
        )}
        startDate={reportSettingState.from}
        endDate={reportSettingState.to}
        dateRangeLabel={dateRangeLabel}
        isValidateRangeValue={true}
      />
    </>
  );
}

export default memo(ReportDateSettingFromTo);
